import cfgJson from "./type.json";
export class AbstractConfigSource {
    constructor(name, stage) {
        this.encrypted = false;
        this.urlPrefix = 'https://config.storyverse.xyz';
        this.backupUrlprefix = 'https://d3ar4smkmrrv66.cloudfront.net';
        this.stage = 'dev';
        this.ts = 0;
        this.loaded = false;
        this.headers = {};
        this.timeout = 10000;
        this.refreshInterval = 120 * 1000;
        this.values = undefined;
        this.name = name;
        this.stage = stage;
    }
    //get filename():string { return `${this.stage}-${this.name}` }
    get filename() { return `${this.name}${this.encrypted ? '' : '.json'}`; }
    get url() { return `${this.urlPrefix}/${this.stage}-${this.filename}`; }
    get file() { return `${this.cacheDir}/${this.stage}-${this.filename}`; }
    /** fetch the configs from the config service & cache the structure in memory.
     * The fetch and/or update are skipped under certain conditions:
     *
     * - `disabled` is truthy
     * - `url` is not set
     * - the config was already fetched recently (within `refreshInterval` ms)
     * - the server returns 304 to a if-none-match request (old config still valid)
     *
     * You can call the method `poll(interval)` to initialize or modify the periodic
     * polling interval, which will repeatedly call this method using a timer.
     */
    async fetch(refresh) {
        var _a;
        if (this.values) {
            if (!refresh)
                return this.values;
            if (Date.now() - this.ts < this.refreshInterval)
                return this.values;
        }
        this.ts = Date.now();
        const res = await this.fetchUrl(this.url);
        if (res.status == 304) {
            return this.values || {};
        }
        if (res.data) {
            this.values = res.data;
            if (res.headers['etag']) {
                this.headers['If-None-Match'] = res.headers['etag'];
                this.headers['If-Modified-Since'] = (_a = res.headers['last-modified']) !== null && _a !== void 0 ? _a : res.headers['date'];
            }
        }
        return this.values || {};
    }
}
/** load and periodically refresh configuration from a web service (or local json files) */
export class ConfigClient {
    constructor(stage, sources) {
        /** auto-refresh interval millis */
        this.refreshInterval = 0;
        /** url to fetch updates */
        this.configSources = [];
        /** disable fetching from the network */
        this.disabled = false;
        this.promise = Promise.resolve(this);
        Object.assign(this, cfgJson);
        if (sources) {
            this.configSources = sources;
        }
        if (!cfg.cfg) {
            cfg.cfg = this;
        }
        if (stage) {
            this.stage = stage;
            this.defineConfigs();
        }
    }
    get domain() {
        return 'storyverse.xyz';
    }
    get stage() {
        return this._stage;
    }
    set stage(stage) {
        if (this._stage && this._stage in cfg) {
            delete cfg[this._stage];
        }
        this._stage = stage;
        if (stage) {
            cfg[stage] = this;
        }
    }
    defineConfigs() { }
    ;
    set sources(sources) { this.configSources = sources; }
    get sources() { return this.configSources; }
    addSource(source) { this.configSources.push(source); }
    loadConfigs(refresh = false) {
        const promises = this.configSources.map((source) => { return source.fetch(refresh); });
        const results = Promise.all(promises).then((values) => {
            Object.assign(this, ...values);
            return this;
        });
        this.promise = this.promise.then(() => results);
        return results;
    }
    update(values) {
        Object.assign(this, values);
    }
    loadCachedConfigs() {
        for (const source of this.configSources) {
            const values = source.loadFromFile();
            if (values) {
                this.update(values);
            }
        }
    }
    /**
     * repeatedly poll for updates after a given interval (given in seconds)
     * Pass `refreshIntervalSeconds=0` to disable polling.
     */
    poll(refreshIntervalSeconds = 120) {
        if (this.disabled) {
            return this;
        }
        this.refreshInterval = refreshIntervalSeconds * 1000;
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        if (!refreshIntervalSeconds) {
            return this;
        }
        this.intervalId = setInterval(() => { this.loadConfigs(true); }, this.refreshInterval);
        return this;
    }
}
export const cfg = {};
//# sourceMappingURL=config.js.map